export interface Confirmation {
   decision: 'ACCEPT' | 'CANCEL' | 'DECLINE' | 'REVIEW' | string;
   ref: string;
}

export class Confirmation implements Confirmation {
   constructor( c: any ) {
      this.decision = c?.decision;
      this.ref = c?.ref;
   }
}
